export default __webpack_public_path__ + "static/media/defaultBg.ef9b90b2.jpg";